import * as React from 'react'
import { MarketingLayout } from '../components/marketing-layout'
import { MarketingPageContainer, PageTitle, MarketingSection } from '../styles/marketing.styles'
import { changelogEntries } from '../data/changelog-entries'
import styled from 'styled-components'

const VersionBlock = styled.div`
  margin-bottom: 2rem;
  h2 { font-size: 1.25rem; margin-bottom: 0.5rem; }
  ul { list-style: none; padding: 0; margin: 0; }
  li { margin-bottom: 0.5rem; font-size: 0.875rem; }
`

const Badge = styled.span<{ type: string }>`
  display: inline-block;
  padding: 0.15rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-right: 0.5rem;
  background: ${(p) =>
    p.type === 'feature' ? '#33AA40' : p.type === 'improvement' ? '#3292C0' : '#9CA6AD'};
  color: #fff;
`

export const ChangelogPage: React.FC = () => (
  <MarketingLayout>
    <MarketingPageContainer>
      <MarketingSection>
        <PageTitle>Changelog</PageTitle>
        <p>Product updates and release notes.</p>
        {changelogEntries.map((entry) => (
          <VersionBlock key={entry.version}>
            <h2>{entry.version} &middot; {entry.date}</h2>
            <ul>
              {entry.changes.map((c, i) => (
                <li key={i}>
                  <Badge type={c.type}>{c.type}</Badge>
                  {c.description}
                </li>
              ))}
            </ul>
          </VersionBlock>
        ))}
      </MarketingSection>
    </MarketingPageContainer>
  </MarketingLayout>
)
